import { OrderStatusGroup, ShippingPartnerName } from '@tcr-erp/shared';
import type { TenantOrder } from '@/mocks/orders';

/**
 * TCR-1094 (comment Jira `33057`, 2026-08-20): nút "In phiếu" bị bỏ ở final
 * fix wave trước (bug fake-success — xem `orderActionColumn.tsx` header) nay
 * quay lại cho đúng 6 nhóm QA yêu cầu (comment `32626`), với điều kiện MỚI:
 * đơn có hãng vận chuyển thật thì in nhãn hãng, KHÔNG phải phiếu xuất hàng.
 */
export const PRINT_SLIP_STATUS_GROUPS: OrderStatusGroup[] = [
  OrderStatusGroup.AWAITING_PACKING,
  OrderStatusGroup.PACKING,
  OrderStatusGroup.AWAITING_HANDOVER,
  OrderStatusGroup.HANDOVER,
  OrderStatusGroup.SHIPPING,
  OrderStatusGroup.COMPLETED,
];

/** 2 hãng duy nhất đã tích hợp tải nhãn (`OFF_PLATFORM_PARTNERS`, `offplatform-fulfillment.ts`) — Ahamove/Viettel Post "Chưa tích hợp". */
const LABEL_DOWNLOAD_CARRIERS = new Set<string>([ShippingPartnerName.BEST, ShippingPartnerName.GHTK]);

export type PrintSlipMode =
  | { kind: 'export-slip' }
  | { kind: 'carrier-label'; shippingOrderId: string }
  | { kind: 'unavailable'; reason: string };

/**
 * Chốt với người dùng (2026-08-20): đơn tự vận chuyển (MANUAL, hoặc chưa gán
 * hãng nào) → LUÔN in phiếu xuất hàng. Đơn có hãng thật → CHỈ in nhãn hãng khi
 * đã có vận đơn + hãng đã tích hợp tải nhãn + list đã trả `shipping_order_id`;
 * thiếu điều kiện nào thì disable kèm lý do, KHÔNG fallback in phiếu xuất
 * hàng (tránh in nhầm chứng từ cho đơn đang thực sự đi qua hãng).
 */
export function resolvePrintSlipMode(row: Pick<TenantOrder, 'shipping'>): PrintSlipMode {
  const partner = row.shipping?.shipping_partner;
  const isRealCarrier = Boolean(partner?.name) && partner?.name !== ShippingPartnerName.MANUAL;
  if (!isRealCarrier) return { kind: 'export-slip' };

  if (!LABEL_DOWNLOAD_CARRIERS.has(partner!.name)) {
    return { kind: 'unavailable', reason: 'Hãng vận chuyển chưa hỗ trợ tải nhãn — chưa thể in phiếu' };
  }
  if (!partner?.order_id) {
    return { kind: 'unavailable', reason: 'Đơn chưa có vận đơn — chưa thể in phiếu' };
  }
  const shippingOrderId = row.shipping?.shipping_order_id;
  if (!shippingOrderId) {
    return { kind: 'unavailable', reason: 'Đơn chưa có vận đơn — chưa thể in phiếu' };
  }
  return { kind: 'carrier-label', shippingOrderId };
}
